import React from 'react';
import { CalendarIcon, ClockIcon, CreditCardIcon, FileTextIcon, GaugeIcon, GiftIcon, HomeIcon, LockIcon, ShieldCheckIcon, StarIcon, UsersIcon } from 'lucide-react';
import { mockupUrl } from '../data/content';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-16" data-id="element-188" data-mp="4mi3tby6fqf0">
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-189" data-mp="12a0n3gpgsax9">
        <div className="mb-5 inline-flex rounded-full border border-accent/20 bg-accent/10 px-4 py-1.5 font-display text-[11px] font-bold uppercase tracking-wider text-primary md:mb-7" data-id="element-190" data-mp="127ect9b6vhbc">
          🏃 Compra Digital Ya™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-extrabold leading-[1.1] tracking-tight text-slate-900 md:text-6xl" data-id="element-191" data-mp="ncq13df73mna">
          Tu movilidad, <span className="text-rose" data-id="element-192" data-mp="3d33ecx6girk8">lista desde hoy.</span>
        </h1>
        <p className="mx-auto mt-4 max-w-2xl font-display text-sm font-bold uppercase tracking-[.12em] text-accent md:text-lg" data-id="element-193" data-mp="3825w6klg5xiq">
          Combo Completo Movilidad y Flexibilidad
        </p>
        <a href="#pricing" className="group my-5 flex justify-center rounded-3xl focus:outline-none md:my-7" aria-label="Ver las opciones de compra del Combo Completo Movilidad y Flexibilidad" data-id="element-194" data-mp="3o7vk1k75dnxa">
          <img className="w-full max-w-[620px] object-contain drop-shadow-[0_24px_38px_rgba(109,40,217,.22)] transition-transform duration-300 ease-out group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Movilidad y Flexibilidad 2026 con sus 5 tomos y 5 bonos" data-id="element-195" data-mp="3e7uxzqhw8tpe" />
        </a>
        <p className="mx-auto max-w-3xl text-base font-medium leading-relaxed text-slate-600 md:text-xl" data-id="element-196" data-mp="2viy4vpy8g78r">
          <strong className="text-slate-900" data-id="element-197" data-mp="2hjf8tvip4mct">
            COMBO COMPLETO MOVILIDAD Y FLEXIBILIDAD 2026.
          </strong>{' '}
          El programa completo para moverte mejor, reducir la rigidez y ganar flexibilidad real. Para
          cualquier persona, en casa o en el gimnasio, sin equipamiento especial.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-medium text-slate-600 md:text-sm" data-id="element-198" data-mp="naa12rwhfkmi">
          <span className="flex items-center gap-1.5" data-id="element-199" data-mp="icrngo7ish86">
            <FileTextIcon className="h-4 w-4 text-accent" data-id="element-200" data-mp="ddngm482ivl0" />
            100% PDF
          </span>
          <span className="flex items-center gap-1.5" data-id="element-201" data-mp="1b1fg54ulm8vr">
            <ClockIcon className="h-4 w-4 text-accent" data-id="element-202" data-mp="1b04at0li8t2j" />
            Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-203" data-mp="162m3tfr1snx6">
            <CalendarIcon className="h-4 w-4 text-accent" data-id="element-204" data-mp="111yb8pn67z0u" />
            Edición 2026
          </span>
          <span className="flex items-center gap-1.5" data-id="element-205" data-mp="x1wbim0zxfo7">
            <HomeIcon className="h-4 w-4 text-accent" data-id="element-206" data-mp="x3h1dycd8afq" />
            Casa o gimnasio
          </span>
          <span className="flex items-center gap-1.5" data-id="element-207" data-mp="3lqm3q21erbwi">
            <GaugeIcon className="h-4 w-4 text-accent" data-id="element-208" data-mp="3hqkamh9qnqsu" />
            Todos los niveles
          </span>
        </div>
        <div className="mt-7" data-id="element-209" data-mp="1xb5q6f7x0tgn">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-210" data-mp="21awca5mhyleu">
            QUIERO EL SISTEMA COMPLETO →
          </Button>
        </div>
        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-medium text-slate-500 md:text-sm" data-id="element-211" data-mp="268ofhvsldtyc">
          <span className="flex items-center gap-1" data-id="element-212" data-mp="2fzsswr2md6r2">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-213" data-mp="2fzaov89pto8l" />
            Garantía 7 días
          </span>
          <span className="text-violet-300" data-id="element-214" data-mp="2kx2ge16g78c9">·</span>
          <span className="flex items-center gap-1" data-id="element-215" data-mp="2ozz5maqhu2p6">
            <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-216" data-mp="2oye8qegpi7o5" />
            Pago seguro
          </span>
          <span className="text-violet-300" data-id="element-217" data-mp="2txhe600lmfwn">·</span>
          <span className="flex items-center gap-1" data-id="element-218" data-mp="un9a5okh8lfo">
            <CreditCardIcon className="h-3.5 w-3.5 text-accent" data-id="element-219" data-mp="uou3xbyyw0ch" />
            Mercado Pago
          </span>
        </div>
        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-220" data-mp="4b46ts95i2ix">
          <TrustCard icon={<StarIcon className="h-5 w-5 fill-rose text-rose" data-id="element-222" data-mp="3vi6y0jozo8t5" />} text="4,9/5 · ★★★★★" data-id="element-221" data-mp="4d75t1sa75zs" />
          <TrustCard icon={<UsersIcon className="h-5 w-5 text-accent" data-id="element-224" data-mp="e91tibbd3r9f" />} text="+700 personas ya lo usan" data-id="element-223" data-mp="e9tqnqklxx1t" />
          <TrustCard icon={<FileTextIcon className="h-5 w-5 text-accent" data-id="element-226" data-mp="3hqa9epmj4h1i" />} text="5 Tomos listos para usar" data-id="element-225" data-mp="9b8nbia26x95" />
          <TrustCard icon={<GiftIcon className="h-5 w-5 text-accent" data-id="element-228" data-mp="3cs8u8fs851vb" />} text="5 Bonos incluidos gratis" data-id="element-227" data-mp="3crpk3l8tfhru" />
        </div>
      </div>
    </section>;
}
function TrustCard({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex flex-col items-center gap-2 rounded-2xl border border-violet-100 bg-white p-3 shadow-sm" data-id="element-229" data-mp="3mnir6p3rmj28">
      <span data-id="element-230" data-mp="2u0y1ru6uoh1b">{icon}</span>
      <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-231" data-mp="2u1hij7krkzdr">
        {text}
      </span>
    </div>;
}